import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Verificar si el usuario está autenticado
 * Busca en ambos storages (localStorage y sessionStorage)
 */
const isAuthenticated = () => {
  const authTokenInLocal = localStorage.getItem('authToken');
  const authTokenInSession = sessionStorage.getItem('authToken');
  return !!(authTokenInLocal || authTokenInSession);
};

/**
 * Componente de ruta privada mejorado
 * Protege rutas que requieren autenticación
 */
const PrivateRoute = ({ element }) => {
  if (!isAuthenticated()) {
    // Limpiar cualquier dato residual de ambos storages
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userData');
    localStorage.removeItem('displayName');
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('refreshToken');
    
    // Redirigir al login
    return <Navigate to="/" replace />;
  }
  
  return element;
};

export default PrivateRoute;
